import { redirect } from '@tanstack/react-router';

/**
 * What the wizard's URL may carry. Only a provider's refusal ever sets it, so
 * the key is absent rather than undefined the rest of the time — an optional
 * key is what lets every step be navigated to without naming a search at all.
 */
export interface OnboardingSearch {
  error?: string;
}

/** Reads the one parameter the wizard understands, and drops everything else. */
export function onboardingSearch(search: Record<string, unknown>): OnboardingSearch {
  return typeof search.error === 'string' ? { error: search.error } : {};
}

/**
 * `/onboarding` is a door, and it decides nothing.
 *
 * It used to look at whether a calendar was connected and skip ahead, which
 * carried people — including the one returning from a provider's consent
 * screen — straight past the screen that was supposed to tell them it had
 * worked. Now every visit lands on the first screen, and "already connected"
 * is the calendar step's own state rather than a reason to be moved along.
 *
 * It replaces the entry in history rather than adding to it, so Back from the
 * first step leaves the wizard instead of bouncing through the door again. A
 * provider's refusal returns to the step that asked rather than to the door,
 * but the door carries the search along all the same: dropping a parameter on
 * the way through is how a reason goes missing.
 */
export function onboardingEntry(search: OnboardingSearch): never {
  throw redirect({ to: '/onboarding/welcome', search, replace: true });
}
